import React from 'react';
import MetricChangePercent from '@/pages/datalab/components/MetricUpAndDownComponents/MetricChangePercent';
import './index.scss';

interface IMetricChangeSmallBoxProps {
  title?: React.ReactNode;
  change?: number | string | null;
  showChange?: boolean;
}

// 环比、同期变化率展示
const MetricChangeSmallBox: React.FC<IMetricChangeSmallBoxProps> = ({
  title,
  change,
  showChange,
  ...rest
}) => {
  return (
    <div className="dbl-metric-change-box-small" {...rest}>
      <div className="dbl-change-title">{title}</div>
      {showChange ? (
        <MetricChangePercent value={change} className="dbl-change-value" />
      ) : null}
    </div>
  );
};

export default MetricChangeSmallBox;